import { z } from "zod";
import { ReportExecutionHistoryParameterValueDtoSchema } from "@/Schemas/Reports/ReportExecutionHistoryParameterValueDto";
import { ReportParameterHistoryDtoSchema } from "./ReportParameterHistoryDto";

export const ReportExecutionHistoryParameterDtoSchema = z.object({
    reportParameterId: z.string(),
    values: z.array(ReportExecutionHistoryParameterValueDtoSchema),
    reportParameter: ReportParameterHistoryDtoSchema.nullable().optional(),
});

export type ReportExecutionHistoryParameterDto = z.infer<typeof ReportExecutionHistoryParameterDtoSchema>;


